import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { system as styledSystem } from '@styled-system/core';

const styledParser = styledSystem({
  marginLeft: true,
  marginRight: true,
  marginTop: true,
  marginBottom: true,
});

const SR_ICON_DISPLAY_TO_CLASSNAME_MAPPING = {
  inlineBlock: 'display-inline-block',
};

const SR_ICON_CURSOR_TO_CLASSNAME_MAPPING = {
  pointer: 'cursor-pointer',
};

const SrIcon = ({ display, cursor, className, ..._styles }) => {
  return (
    <div
      className={classnames(
        'SrIcon',
        SR_ICON_DISPLAY_TO_CLASSNAME_MAPPING[display],
        SR_ICON_CURSOR_TO_CLASSNAME_MAPPING[cursor],
        className,
      )}
      style={styledParser(_styles)}
    />
  );
};

const inlineStyleProp = PropTypes.oneOfType([
  PropTypes.string,
  PropTypes.number,
]);

SrIcon.propTypes = {
  display: PropTypes.oneOf(Object.keys(SR_ICON_DISPLAY_TO_CLASSNAME_MAPPING)),
  cursor: PropTypes.oneOf(Object.keys(SR_ICON_CURSOR_TO_CLASSNAME_MAPPING)),
  className: PropTypes.string.isRequired,
  marginLeft: inlineStyleProp,
  marginRight: inlineStyleProp,
  marginTop: inlineStyleProp,
  marginBottom: inlineStyleProp,
};

SrIcon.displayName = 'SrIcon';

export default SrIcon;
